import type { DependencyList } from 'react';
import { useCallback, useEffect, useRef } from 'react';

type UseSetTimeoutOptions = {
  autoStart?: boolean;
  deps?: DependencyList;
};

export function useSetTimeout(
  callback: () => void,
  delay: number,
  { autoStart = true, deps = [] }: UseSetTimeoutOptions = {},
) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => {
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    },
    autoStart ? deps : [],
  );

  const reset = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    // eslint-disable-next-line fp/no-mutation
    timeoutRef.current = setTimeout(callback, delay);
  }, [callback, delay]);

  useEffect(
    () => {
      if (autoStart) {
        reset();
      }
    },
    autoStart ? deps : [],
  );

  return reset;
}
